<template>
	<transition name="modal">
		<div v-if="showModal" @close="showModal = false">
			
				<div class="modal-mask" >
				  <div class="modal-wrapper">
				    <div class="modal-container">

				      <div class="modal-header">
				        <h3 v-html="modalTitle"></h3>
				      </div>

				      <div class="modal-body" v-html="modalContent">
				        
				      </div>

				      <div class="modal-footer">
							<md-button class="md-flat md-primary modal-default-button" style='color:#000;min-width:30px;width:30px;' @click="dialogDoAction">
								{{modalDoButton}}
							</md-button>
							<md-button class="md-flat md-accent modal-default-button" style='color:#888;min-width:30px;width:30px;' @click="dialogClose" v-if="modalCancleView">
								{{modalCancleButton}}
							</md-button>
							<div style="clear:both;"></div>
				      </div>

				    </div>
				  </div>
				</div>
			
		</div>	
	</transition>
	
</template>


<script>
export default {
  name: 'DialogModal',
  created() {
	  this.$eventBus.$on('dialogOpen', this.modalOpen);
 
  },
  data() {
	  return {
		showModal:false,
	    modalTitle:'알림',
		modalContent:'메세지',
		modalCancleButton:'취소',
		modalDoButton:'확인',
		modalCancleView:false,
		modalCancleAction:false,
		modalDoAction:false,
		modalEl:false,
		
  	  }
  },
  methods: {
	modalOpen(params) {
		
		if(params.title)this.modalTitle = params.title;
		else this.modalTitle = '알림';
		if(params.content)this.modalContent = params.content;
		
		if(params.doButton)this.modalDoButton = params.doButton;
		else this.modalDoButton = '확인';

		if(params.doAction) this.modalDoAction = params.doAction;
		else  this.modalDoAction = false;
		
		if(params.confirm) {
			this.modalCancleView = true;
			if(params.cancleButton)	this.modalCancleButton = params.cancleButton;
			if(params.cancleAction) this.modalCancleAction = params.cancleAction;
		} else {
			this.modalCancleView = false;
			this.modalCancleButton = '취소';
			this.modalCancleAction = false;
		}
		
		if(params.cancleView)this.modalCancleView = true;
		else this.modalCancleView = false;

		if(params.el)this.modalEl = params.el;
		else this.modalEl = false;

		this.showModal=true;
	},
	dialogClose() {
		this.showModal=false;
		if(this.modalCancleAction) {
			eval(this.modalCancleAction());
		}
	},
	dialogDoAction() {
		this.showModal=false;
		//if(this.modalEl)this.$eventBus.$emit('failAction',this.modalEl);
		if(this.modalDoAction) {
			eval(this.modalDoAction());
			//this.$eventBus.$emit(this.modalDoAction);
		}
	}
  },
  updated() {
	
  }
}
</script>


<style lang="scss" scoped>
 
.modal-mask {
  position: fixed;
  z-index: 9998000000000000000;
  top: 0;
  left: 0;
  width: 100%;
  height:calc(100vh);
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;

}

.modal-header h3 {
  margin-top: 0;
  color: #000;
}

.modal-body {
  margin: 20px 0;
}

.modal-footer {
  text-align: right;
  width:100%;
}
.modal-default-button {float:right;width:40px;}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}



</style>